import { ref } from "vue";
import { defineStore } from "pinia";
import objectPath from "object-path";
import type LayoutConfigTypes from "@/core/config/LayoutConfigTypes";
import layoutConfig from "@/core/config/DefaultLayoutConfig";
import DBConfigService from "@/core/services/DBConfigService";

export const LS_CONFIG_NAME_KEY = "config_" + import.meta.env.VITE_APP_NAME;

export const useConfigStore = defineStore("config", () => {
  const config = ref<LayoutConfigTypes>(layoutConfig);
  const initial = ref<LayoutConfigTypes>(layoutConfig);

  function getLayoutConfig(path: string, defaultValue?: string) {
    return objectPath.get(config.value, path, defaultValue);
  }

  async function setLayoutConfigProperty(property: string, value: any) {
    objectPath.set(config.value, property, value);
    await DBConfigService.setParam(LS_CONFIG_NAME_KEY, JSON.stringify(config.value));
  }

  function resetLayoutConfig() {
    config.value = Object.assign({}, initial.value);
  }

  async function overrideLayoutConfig() {
    const savedConfig = await DBConfigService.getParam(LS_CONFIG_NAME_KEY);
    config.value = initial.value = Object.assign(
      {},
      initial.value,
      savedConfig ? JSON.parse(savedConfig) : {}
    );
  }

  return {
    config,
    getLayoutConfig,
    setLayoutConfigProperty,
    resetLayoutConfig,
    overrideLayoutConfig,
  };
});
